import template from "./organization-image.html";

const OrganizationImageComponent = {
  template: template,
  controller: class OrganizationImageController {
    /* @ngInject */
    constructor($rootScope, $scope) {
      this.$rootScope = $rootScope;
      this.$scope = $scope;
    }

    $onInit() {
      this.organization = this.$rootScope.organization;
      this.$scope.$on("refreshOrganization", () => (this.organization = this.$rootScope.organization));
    }
  },
};

export default OrganizationImageComponent;
